import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "home",
    children: [
      {
        path: "home",
        component: () => import("@/views/index"),
        name: "Index",
        meta: { title: "首页", id: 1, parentId: 0, img: null, type: 0 },
      },
      {
        path: "about",
        component: () => import("@/views/template/page"),
        name: "About",
        meta: {
          title: "关于我们",
          id: 4,
          parentId: 0,
          img: "//img.yqelectric.net/img/CgoKR2Ho6yqABHhSAA7jdbFyNdM160.png",
          type: 1,
        },
      },
      {
        path: "partner",
        component: () => import("@/views/partner/index"),
        name: "Partner",
        meta: {
          title: "集群伙伴",
          id: 3,
          parentId: 2,
          img: "//img.yqelectric.net/img/CgoKR2Ho6ciAKDkzAA3OzVRvdr4145.png",
          type: 2,
        },
      },
      {
        path: "organization",
        component: () => import("@/views/template/page"),
        name: "Organization",
        meta: {
          title: "组织机构",
          id: 5,
          parentId: 0,
          img: "//img.yqelectric.net/img/CgoKR2Ho64GAEgv-AA4g7A8AAuA506.jpg",
          type: 1,
        },
      },
      {
        path: "contact",
        component: () => import("@/views/contact/index"),
        name: "Contact",
        meta: {
          title: "联系我们",
          id: 6,
          parentId: 0,
          img: "//img.yqelectric.net/img/CgoKR2Ho84GAXrM3AA00d-6nQeo526.jpg",
          type: 1,
        },
      },
      {
        path: "news",
        component: () => import("@/views/news/index"),
        name: "News",
        meta: {
          title: "资讯中心",
          id: 2,
          parentId: 0,
          img: "//img.yqelectric.net/img/CgoKR2Hoq1uACie9AA192AD9AeM780.jpg",
          type: 0,
        },
        children: [
          {
            path: "industry",
            component: () => import("@/views/news/index"),
            name: "Industry",
            meta: {
              title: "行业资讯",
              id: 7,
              parentId: 2,
              img: "//img.yqelectric.net/img/CgoKR2Hoq1uACie9AA192AD9AeM780.jpg",
              type: 2,
            },
          },
          {
            path: "train",
            component: () => import("@/views/news/index"),
            name: "Train",
            meta: {
              title: "培训信息",
              id: 8,
              parentId: 2,
              img: "//img.yqelectric.net/img/CgoKR2Hoq1uACie9AA192AD9AeM780.jpg",
              type: 2,
            },
          },
        ],
      },
      {
        path: "newsView/:id",
        component: () => import("@/views/news/newsView"),
        name: "NewsView",
        meta: {
          title: "新闻详情",
          img: "//img.yqelectric.net/img/CgoKR2Hoq1uACie9AA192AD9AeM780.jpg",
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title + " - 乐清电气产业创新发展服务中心";
  }
  next();
});
export default router;
